<template>
    <v-layout justify-center>
        <v-dialog v-model="show" max-width="400px">
            <v-card>
                <v-card-title class="ma-0 pa-0">
                    <v-toolbar dark color="blue lighten-2">
                        <v-btn icon dark @click="show = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <span class="headline" v-if="editButtonIndex == null">Создать новую кнопку</span>
                        <span class="headline" v-else>Изменить кнопку</span>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                icon
                                text
                                @click="confirmDialog = true"
                        >
                            <v-icon>delete</v-icon>
                        </v-btn>
                        <v-btn dark text @click="copyButton" title="Создать копию кнопки на новой строке">
                            <v-icon>file_copy</v-icon>
                        </v-btn>
                    </v-toolbar>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md v-if="show">
                        <v-layout wrap>
                            <v-flex xs12 sm12 md12 v-if="buttons.length > 0">
                                <v-text-field
                                        label="Название кнопки"
                                        required
                                        v-model="buttonModel.label"
                                        :counter="28"
                                        @change="saveButton"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-select
                                        :items="buttonTypes"
                                        label="Тип кнопки"
                                        v-model="buttonModel.type"
                                        @change="saveButton"
                                        hide-details/>
                            </v-flex>
                            <v-flex xs12 v-show="buttonModel.type === 'action'">
                                <v-select
                                        :items="controllerItems"
                                        label="Список разделов"
                                        v-model="buttonModel.controller"
                                        @change="saveButton"
                                        hide-details/>
                            </v-flex>
                            <v-flex xs12 v-show="buttonModel.type === 'action'">
                                <v-select
                                        :items="actionItems"
                                        label="Список действий"
                                        v-model="buttonModel.action"
                                        @change="saveButton"
                                        hide-details

                                />
                            </v-flex>

                            <v-flex xs12 v-show="buttonModel.type !== 'action'">
                                <v-select
                                        :items="[{value:0, text:'Адресация на сообщение'},{value:1, text:'Группа модулей'}]"
                                        label="Действие"
                                        v-model="buttonModel.func"
                                        @change="saveButton"
                                        :value="0"
                                        hide-details/>
                            </v-flex>
                            <v-flex xs12 v-show="buttonModel.func === 0">
                                <v-select
                                        :items="messages"
                                        label="Сообщение"
                                        v-model="buttonModel.message_id"
                                        @change="saveButton"
                                        item-text="title"
                                        item-value="id"
                                        hide-details/>
                            </v-flex>
                            <v-flex xs12 v-show="buttonModel.action === 'selectDelivery'">
                                <v-select
                                        :items="deliveries"
                                        label="Выбрать адрес"
                                        v-model="buttonModel.delivery_id"
                                        @change="saveButton"
                                        item-text="title"
                                        item-value="id"
                                        hide-details/>
                            </v-flex>
                            <v-flex xs12 v-show="buttonModel.func === 1 && buttonModel.type !== 'action'" >
                                <v-select
                                        :items="moduleGroups"
                                        label="Модули"
                                        v-model="buttonModel.module_group_id"
                                        @change="saveButton"
                                        item-text="title"
                                        item-value="id"
                                        hide-details
                                ></v-select>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                                <v-select
                                        :items="colors"
                                        label="Цвет кнопки"
                                        v-model="buttonModel.color"
                                        @change="saveButton"
                                        hide-details/>
                            </v-flex>
                          <v-flex xs6 sm6 md6>
                            <v-checkbox class="pa-0 ma-1 mx-2"
                                        v-model="buttonModel.rnd"
                                        label="Перемешать кнопку"
                                        :color="'success'"
                                        true-value="1"
                                        false-value="0"
                                        success-text="false"
                                        hide-details
                                        @change="saveButton"
                            ></v-checkbox>
                          </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="buttonModel.value"
                                          label="URL" color="primary"
                                              @input="saveButton"
                                          v-show="buttonModel.type === 'url'"/>
                            </v-flex>

                            <v-flex xs6 sm6 md6 v-if="keyboardModel.hotkey == 1">
                               <!-- <v-select
                                        :items="[1,2,3,4,5,6,7,8,9,10]"
                                        label="Горячая клавиша"
                                        v-model="buttonModel.hotkey_val"
                                        @change="saveButton"
                                        v-if="keyboardModel.hotkey == 1"
                                ></v-select>-->
                                <v-text-field v-model="buttonModel.hotkey_val"
                                              label="Горячая клавиша"
                                              @input="saveButton"

                                              title="если значение пустое, тогда будет использоваться название клавиши"
                                />
                            </v-flex>

                            <v-flex xs12>
                                <v-select
                                        :items="[{value:1, text:'Бот включен'},{value:0, text:'Бот выключен'},{value:2, text:'Всегда'}]"
                                        label="Условие работы"
                                        v-model="buttonModel.work"
                                        @change="saveButton"
                                        value="1"
                                        item-text="text"
                                        item-value="value"
                                ></v-select>
                            </v-flex>
                            <v-col cols="12" md12 class="py-0 px-7">
                                <MailingGroupsPicker
                                        newLabel="Видимость группам"
                                        newFieldName="group_ids"
                                        :selectedMailingGroups="selectedMailingGroups.group_ids"
                                        :mailingGroups="mailingGroups"
                                        :edit="true"
                                        @updateGroups="updateGroups"
                                ></MailingGroupsPicker>
                            </v-col>
                            <v-flex xs12>
                                <variables-select-form
                                        :variables="buttonModel.variables"
                                        @selectVariable="selectVariable"
                                        @deleteVariable="deleteVariable"
                                        @changeValueVariable="changeValueVariable"
                                ></variables-select-form>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="confirmDialog"
                max-width="300"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2">Подтвердите удаление</v-card-title>
                <v-card-text>
                    Вы действительно хотите удалить?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="green darken-1"
                            text
                            @click="confirmDialog = false"
                    >
                        Отмена
                    </v-btn>

                    <v-btn
                            color="error darken-1"
                            text
                            @click="removeButton"
                    >
                        Подтверждаю
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import VariablesSelectForm from '../scenarios/forms/VariablesSelectForm'
import MailingGroupsPicker from '../mailing/MailingGroupsPicker'
import messageConstants from './messageConstants'
export default {
    name: 'ButtonForm',
    components: {
        VariablesSelectForm,
        MailingGroupsPicker
    },
    data() {
        return {
            confirmDialog: false,
            keyboardModel: { hotkey: 0 },
            buttonModelDB: null,
            buttonModel: null,
            colors: ['primary', 'default', 'error', 'success'],
            work: ['bot_on', 'bot_off', 'always'],
            selectedMailingGroups: { group_ids: [], excepts: [] }
        }
    },
    props: ['visible', 'buttons', 'keyboardId', 'editButtonIndex'],
    methods: {
        saveButton() { // изменение: названия, цвета
            if (!this.buttonModel.hasOwnProperty('variables')) {
                this.$set(this.buttonModel, 'variables', [])
            }
            if (!this.buttonModel.hasOwnProperty('rnd')) {
                this.$set(this.buttonModel, 'rnd', 0)
            }
            if (this.buttonModel.type === 'text') {
                if (this.buttonModel.func === 0) {
                    this.buttonModel.module_group_id = null
                } else if (this.buttonModel.func === 1) {
                    this.buttonModel.message_id = null
                }
            }
            this.$emit('saveKeyboard', { action: 'saveButton', model: this.buttonModel })
        },
        copyButton() { // изменение: названия, цвета
            if (!this.buttonModel.hasOwnProperty('variables')) {
                this.$set(this.buttonModel, 'variables', [])
            }
            this.$emit('saveKeyboard', { action: 'copyButton', model: this.buttonModel })
        },
        removeButton() {
            this.$emit('saveKeyboard', { action: 'removeTempButton' })
            this.confirmDialog = false
            this.show = false
        },
        loadModel() {
            if (typeof this.buttons[this.editButtonIndex[0]] !== 'undefined') {
                this.buttonModel = Object.assign({}, this.buttons[this.editButtonIndex[0]][this.editButtonIndex[1]])
                if (!this.buttonModel.hasOwnProperty('variables')) {
                    this.$set(this.buttonModel, 'variables', [])
                }
                if (!this.buttonModel.hasOwnProperty('group_ids')) {
                    this.$set(this.buttonModel, 'group_ids', [])
                }
                if (!this.buttonModel.hasOwnProperty('value')) {
                    this.$set(this.buttonModel, 'value', '')
                }
                this.selectedMailingGroups.group_ids = []
                for (let j = 0; j < this.mailingGroups.length; j++) {
                    for (let i = 0; i < this.buttonModel.group_ids.length; i++) {
                        if (this.buttonModel.group_ids[i] === this.mailingGroups[j].id) {
                            this.selectedMailingGroups.group_ids.push(this.mailingGroups[j])
                        }
                    }
                }
            }
        },
        selectVariable(variable) {
            this.buttonModel.variables.push({ id: variable.id, change_after_press: '' })
            this.saveButton()
        },
        deleteVariable(variableId) {
            let index = this.buttonModel.variables.findIndex(variable => variable.id === variableId)
            this.buttonModel.variables.splice(index, 1)
            this.saveButton()
        },
        changeValueVariable(payload) {
            let index = this.buttonModel.variables.findIndex(variable => variable.id === payload.variableId)
            this.buttonModel.variables[index].change_after_press = payload.value
            this.saveButton()
        },
        updateGroups(data) {
            let groupIds = []
            for (let i = 0; i < data.selectedMailingGroups.length; i++) {
                groupIds.push(data.selectedMailingGroups[i].id)
            }
            this.buttonModel[data.field] = groupIds
            this.saveButton()
        }
    },
    computed: {
        show: {
            get(value) {
                if (value) {
                    this.loadModel()
                }
                return this.visible
            },
            set(value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },
        ...mapState([
            'scenarios'
        ]),
        ...mapGetters({
            variablesLoaded: 'scenarios/variablesLoaded',
            keyboards: 'keyboards/keyboards',
            getKeyboardById: 'keyboards/getKeyboardById',
            moduleGroups: 'moduleGroups/moduleGroupsForSelectGroup',
            mailingGroups: 'mailingGroups/mailingGroups',
            messages: 'messages/getMessages',
            deliveries: 'cards/deliveries'
        }),
        actionItems() {
            let actions = messageConstants.actions
            return actions[this.buttonModel.controller]
        },
        controllerItems() {
            return messageConstants.controllerItems
        },
        buttonTypes() {
            return messageConstants.buttonTypes
        }
    },
    watch: {
        show(value) {
            if (value) {
                this.keyboardModel = Object.assign({}, this.getKeyboardById(this.keyboardId))
            } else {
                this.keyboardModel = Object.assign({}, this.getKeyboardById(this.keyboardId))
            }
        }
    },
    created() {
        this.$store.dispatch('scenarios/variablesAll', this.$route.params['pathMatch'])
        this.$store.dispatch('mailingGroups/loadMailingGroups', this.$route.params['pathMatch'])
        this.$store.dispatch('cards/deliveriesAll', this.$route.params['pathMatch'])
    }
}
</script>

<style scoped>
</style>
